/*-----------------------------------------------------------------
- Comments List
-----------------------------------------------------------------*/
export default {
    no_comment: {
        title      : 'نظری ثبت نشده است !',
        description: 'به عنوان اولین نفر نظر خود را ثبت کنید',
    },
};
